import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { Button, Icon, useLocalizeMessage } from 'libs.nucleus';
import { RichContentEditor, FormatBar, FormatList, AlignContent, FormatLink } from 'libs.react_internal';
export const InfoCardSection = ({ state, onChange, isEditable }) => {
    const translate = useLocalizeMessage();
    const [isAdded, setIsAdded] = useState(!!state.cardInfo);
    const handleAdd = useCallback(() => {
        setIsAdded(true);
    }, []);
    const handleRemove = useCallback(() => {
        setIsAdded(false);
        onChange({ ...state, cardInfo: undefined });
    }, [state, onChange]);
    const handleChange = useCallback((event) => {
        onChange({ ...state, cardInfo: event.value });
    }, [state, onChange]);
    if (!isAdded) {
        return (_jsx("div", { className: 'flex flex-col gap-4', children: isEditable && (_jsx("div", { className: 'self-start', children: _jsx(Button, { label: `+ ${translate('Add info card')}`, variant: 'transparent', onClick: handleAdd }) })) }));
    }
    return (_jsxs("div", { className: 'flex flex-col gap-4', children: [_jsx(RichContentEditor, { id: 'card-info', type: 'textarea', label: translate('Information'), value: state.cardInfo || '', onChange: handleChange, width: 'full', disabled: !isEditable, children: _jsxs(FormatBar, { children: [_jsx(FormatList, {}), _jsx(AlignContent, {}), _jsx(FormatLink, {})] }) }), isEditable && (_jsx("div", { className: 'self-start', children: _jsx(Button, { label: translate('Remove info card'), variant: 'transparent', onClick: handleRemove, content: _jsx(Icon, { name: 'delete', size: 'sm' }) }) }))] }));
};
